import * as React from 'react'
import styled, { css } from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

import { ConfettiBanner } from '../symbols'

type CompactHeaderProps = {
  avatar?: string
  backgroundImage?: string
  name: string
}

export function CompactHeader({ avatar, backgroundImage, name }: CompactHeaderProps): React.ReactElement {
  return (
    <CompactHeaderLayout backgroundImage={backgroundImage}>
      <PageData>
        {avatar && <plume.styles.image.Avatar asDesktop="medium" src={avatar} type="small" />}
        <plume.styles.heading.XXXS asDesktop="M">{name}</plume.styles.heading.XXXS>
      </PageData>
    </CompactHeaderLayout>
  )
}

const CompactHeaderLayout = styled.header<{ backgroundImage?: string }>`
  align-items: center;
  display: flex;
  height: 86px;
  justify-content: center;
  position: relative;

  ${plume.styles.heading.Base} {
    align-self: center;
    color: ${plume.COLORS.PRIMARY_GREY_900};
    margin-bottom: 6px;
    margin-left: 16px;
  }

  ${({ backgroundImage, theme }) => {
    if (backgroundImage) {
      return css`
        background-image: url(${backgroundImage});
        background-position: center;
        background-size: cover;

        ${plume.styles.heading.Base} {
          color: ${plume.COLORS.PRIMARY_GREY_000};
        }

        &::before {
          background: linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 120%);
          content: '';
          display: block;
          height: 100%;
          left: 0;
          position: absolute;
          top: 0;
          width: 100%;
        }
      `
    } else {
      return css`
        background-image: url(${plume.utils.svg.toDataUrl(ConfettiBanner, { theme })});
      `
    }
  }};

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    height: 166px;

    ${plume.styles.heading.Base} {
      margin-left: 18px;
    }
  }
`

const PageData = styled.span`
  display: flex;
  z-index: 2;
`
